var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBatteryCharging = function SvgBatteryCharging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "battery_charging_svg__a",
    width: 19,
    height: 19,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h19v19H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#battery_charging_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M9.18 11.007V13.1q0 .143.146.175.147.032.199-.111l1.236-3.091a.36.36 0 0 0-.028-.342.33.33 0 0 0-.298-.155h-.617V7.482q0-.142-.146-.175-.147-.032-.2.111L8.238 10.51a.36.36 0 0 0 .027.341.33.33 0 0 0 .298.156zm-2.573 5.937a.7.7 0 0 1-.512-.206.7.7 0 0 1-.204-.51V4.21q0-.305.205-.51a.7.7 0 0 1 .51-.205h1.431v-.716q0-.304.206-.51a.7.7 0 0 1 .51-.205h1.492q.304 0 .51.205a.7.7 0 0 1 .205.51v.716h1.431q.304 0 .51.205a.7.7 0 0 1 .206.51v12.02a.7.7 0 0 1-.206.51.7.7 0 0 1-.51.205zm.471-1.187h4.841V4.673H7.08z"
  }))));
};
export default SvgBatteryCharging;